import { render } from "./MatchesReviewStep.vue?vue&type=template&id=6de6d2ed&scoped=true"
import script from "./MatchesReviewStep.vue?vue&type=script&lang=js"
export * from "./MatchesReviewStep.vue?vue&type=script&lang=js"

import "./MatchesReviewStep.vue?vue&type=style&index=0&id=6de6d2ed&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6de6d2ed"]])

export default __exports__